import { useContext, useEffect, useRef, useState } from "react";
// my imports:
import UI from "@/app/lib/ui/ui";
import { Contexts } from "@/app/components/Context";
import { AnyGameObj } from "@/app/lib/game-state/game-types";
import OneOffHint from "@/app/components/OneOffHint";
import { useAnimationTrigger } from "@/app/lib/ui/use-animation-trigger";
// styles
import animation from "@/app/styles/animation.module.css"

export default function Streak() {

    const activeGame: AnyGameObj | null = useContext(Contexts.ActiveGame);
    const ui: UI | null = useContext(Contexts.UI);

    if (!activeGame || !ui) {
        console.warn("bad context in streak component");
        return null;
    }
    
    // HINT LOGIC
    const [isShowingHint, setIsShowingHint] = useState(false);
    const streakRef = useRef<HTMLDivElement | null>(null);

    function toggleHint() {
        setIsShowingHint(!isShowingHint);
    }

    const hintText: string = `Increase your streak by solving puzzles. :)

        Beware! Skipping a puzzle or revealing it resets your streak. :(`

    // STREAK HAPPY/SAD LOGIC
    const happy: string = ':)';
    const sad: string = ":(";

    let feedbackString: string = '';
    if (ui.streakFeedback === "happy") {
        feedbackString += happy;
    }
    else if (ui.streakFeedback === "sad") {
        feedbackString += sad;
    }
    // ------------------------

    // Animations
    const incrementAnim = useAnimationTrigger(
        `${animation.scalePulse} ${animation.fast} ${animation.large}`
    );
    const resetAnim = useAnimationTrigger(
        `${animation.headShake} ${animation.fast} ${animation.large}`
    );
    const happyFeedbackAnim = useAnimationTrigger(
        `${animation.slideUp} ${animation.medium}`
    );
    const sadFeedbackAnim = useAnimationTrigger(
        `${animation.slideDown} ${animation.medium}`
    );
    const feedbackFadeAnim = useAnimationTrigger(
        `${animation.fadeOut} ${animation.slow}`
    );

    let feedbackAnimClass: string = '';
    if (ui.streakFeedback === 'happy') {
        feedbackAnimClass = happyFeedbackAnim.className;
    } else if (ui.streakFeedback === 'sad') {
        feedbackAnimClass = sadFeedbackAnim.className;
    }

    useEffect(() => {

        function feedbackAnim(feedback: UI['streakFeedback']) {
            if (feedback === 'happy') {
                happyFeedbackAnim.trigger();
                feedbackFadeAnim.trigger();
            } else if (feedback === 'sad') {
                sadFeedbackAnim.trigger();
                feedbackFadeAnim.trigger();
            }
        }

        ui.updateState(state => {
            state.streakAnimations = {
                increment: incrementAnim.trigger,
                reset: resetAnim.trigger,
                feedback: feedbackAnim
            }
        })
    }, [])
    
    return (
        <>
        {isShowingHint && streakRef.current !== null &&
            <OneOffHint 
                element={streakRef.current}
                elementOffset={{x: 40, y: 0}}
                text = {hintText}
                linkText="Dismiss"
                setShowing={setIsShowingHint}
            />
        }
        <div
            className={`${resetAnim.className}`}
        >
        <div 
            className={`${incrementAnim.className}`}     
        >
            <div className = 'streak textAsButton'
                style={{marginTop: 4, display: 'inline-flex'}}
                
                tabIndex={0} 
                ref={streakRef}

                onClick={(e) => {
                    e.stopPropagation();
                    toggleHint()
                }}
                onBlur={() => setIsShowingHint(false)}
            >
                streak: {ui.userHistory.streakCount}
                <div
                    className={`${feedbackAnimClass}`}
                >
                    <div
                        className={`${feedbackFadeAnim.className}`}
                        style={{animationDelay: '.5s'}}
                    >
                        &nbsp;{feedbackString}
                    </div>
                </div>
            </div>
        </div>
        </div>
        </>
    )
}